export default __webpack_public_path__ + "static/gviIngoLogo-fa15dadec52a3f685e22b9a4d426a9be.svg";